import React from 'react';

const MasterCardIcon = () => {
	return (
		<svg
			width='40'
			height='40'
			viewBox='0 0 40 40'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className='ml-12'
			title='Master Card'
		>
			<path d='M24.4681 12.5H16.3121V27.5H24.4681V12.5Z' fill='#FF5F00' />
			<path
				d='M16.9243 19.9988C16.9232 18.6108 17.2347 17.2407 17.8351 15.9923C18.4356 14.7438 19.3093 13.6497 20.3901 12.7928C19.0514 11.73 17.4438 11.0691 15.751 10.8857C14.0582 10.7022 12.3484 11.0036 10.8171 11.7554C9.28577 12.5071 7.99471 13.679 7.09147 15.1369C6.18822 16.5948 5.70923 18.2801 5.70923 20C5.70923 21.72 6.18822 23.4052 7.09147 24.8632C7.99471 26.3211 9.28577 27.4929 10.8171 28.2447C12.3484 28.9965 14.0582 29.2979 15.751 29.1144C17.4438 28.931 19.0514 28.2701 20.3901 27.2073C19.3089 26.3501 18.4351 25.2556 17.8346 24.0067C17.2341 22.7578 16.9229 21.3872 16.9243 19.9988Z'
				fill='#EB001B'
			/>
			<path
				d='M34.4429 25.8333V25.1429H34.5788V25H34.2553V25.1429H34.3831V25.8333H34.4429ZM35.0709 25.8333V25H34.973L34.8589 25.5952L34.7447 25H34.6468V25.8333H34.7175V25.2024L34.8235 25.744H34.8969L35.0029 25.2024V25.8333H35.0709Z'
				fill='#F79E1B'
			/>
			<path
				d='M35.0709 20.0013C35.0709 21.7212 34.5918 23.4064 33.6885 24.8642C32.7852 26.322 31.494 27.4937 29.9627 28.2452C28.4313 28.9968 26.7215 29.298 25.0287 29.1143C23.336 28.9306 21.7285 28.2695 20.3901 27.2065C21.4704 26.3489 22.3437 25.2546 22.9443 24.0062C23.5448 22.7579 23.8568 21.388 23.8568 20C23.8568 18.6121 23.5448 17.2422 22.9443 15.9939C22.3437 14.7455 21.4704 13.6512 20.3901 12.7936C21.7285 11.7306 23.336 11.0695 25.0287 10.8858C26.7215 10.7021 28.4313 11.0033 29.9627 11.7548C31.494 12.5064 32.7852 13.6781 33.6885 15.1359C34.5918 16.5937 35.0709 18.2789 35.0709 19.9988V20.0013Z'
				fill='#F79E1B'
			/>
		</svg>
	);
};

export default MasterCardIcon;
